<p class="align-middle text-center text-secondary">
  <fa-icon [icon]="faSpinner" animation="pulse" [size]="fasize"></fa-icon>
</p>
